<template>
  <v-card class="h-100">
    <v-card-title primary-title>
      Kampanie
    </v-card-title>

    <v-card-text>
      <v-autocomplete
        v-if="editable"
        :value="value"
        :items="filtersOptions.campaigns"
        placeholder="Wybierz kampanie"
        item-text="name"
        item-value="id"
        v-bind="staticData.chipsMultiselectProps"
        @input="$emit('input', $event)"
      />
      <div v-else>
        <template v-if="value.length">
          <v-btn
            v-for="campaign in value"
            :key="'tag'+campaign.id"
            text
            color="golden"
            :to="{ path: '/projects', query: { campaignId: campaign.id } }"
          >
            {{ campaign.name }}
          </v-btn>
        </template>
        <div
          v-else
          class="primary--text text-body-2"
        >
          Projekt nie jest dodany do kampanii
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import props from '@/helpers/componentsProps';

export default {
  props: {
    value: { // campaigns
      type: Array,
      required: true,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    staticData: {
      chipsMultiselectProps: props.chipsMultiselect,
    },
  }),
  computed: {
    ...mapState('filters', [
      'filtersOptions',
    ]),
  },
};
</script>
